import SiteLogo from './SiteLogo';
export default SiteLogo;